import type { DateTime } from "luxon";
import type { CreateHolidayInput } from "@/gql/graphql";

// Holiday form data
export interface HolidayFormData {
  name: string;
  message?: string;
  startDateTime: DateTime;
  endDateTime: DateTime;
  blockOnlineBooking: boolean;
}

export type HolidayTarget = Pick<CreateHolidayInput, "scope" | "salonIds">;

// Holiday display data (from GraphQL)
export interface Holiday {
  id: string;
  franchiseId: string;
  name: string;
  message?: string;
  startDateTime: string;
  endDateTime: string;
  blockOnlineBooking: boolean;
  scope: HolidayScope;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  holidaySalons?: HolidaySalon[];
}

export interface HolidaySalon {
  id: string;
  salonId: string;
  salon?: {
    id: string;
    name: string;
  };
}

export enum HolidayScope {
  FRANCHISE_WIDE = "FRANCHISE_WIDE",
  SALON_SPECIFIC = "SALON_SPECIFIC",
}

// Filter options
export interface HolidayFilters {
  timeFilter?: "future" | "past" | "current";
  scope?: HolidayScope;
  isActive?: boolean;
}
